module.exports = __webpack_public_path__ + "assets/2dc03e9e5d3df4d2ee03d64e8f2fae66.svg";